import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as FPT from '../../utility/fpt';
import { Icon } from '@paypalcorp/pp-react-icons';

const STYLES = {
  error: {
    color: '#D20000',
    fontSize: '13px',
  },
  criticalIcon: {
    color: '#D20000',
    position: 'relative',
    fontSize: 'unset',
    marginRight: '5px',
  },
};

/**
 * Component for displaying amount validation error message
 */
class AmountValidationError extends Component {
  componentDidMount() {
    const { errorSourceField, donationAmount } = this.props;
    FPT.trackError({
      message: `Donation Amount: ${donationAmount}`,
      fieldId: errorSourceField,
      code: 'MINIMUM_DONATION_ERROR',
    });
  }
  render() {
    const { errorString } = this.props;

    if (!errorString) {
      return null;
    }

    return (
      <span>
        <Icon
          name="critical-alt"
          size="xs"
          style={{ ...STYLES.criticalIcon }}
        />
        <span
          role="alert"
          style={STYLES.error}
          data-testid="amount-validation-error"
        >
          {errorString}
        </span>
      </span>
    );
  }
}

AmountValidationError.propTypes = {
  errorString: PropTypes.string,
  errorSourceField: PropTypes.string,
  donationAmount: PropTypes.string,
};

export default AmountValidationError;
